import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";

import { TextField, Button } from "@material-ui/core";

export const PasswordEntryComponent = ({
  passwordRecord,
  submitRecord,
  errorObj,
  lang,
  isUpdate,
}) => {
  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
  } = useForm({
    defaultValues: {
      title: passwordRecord.title,
      link: passwordRecord.link,
      fusername: passwordRecord.username,
      fpassword: passwordRecord.password,
      option1: passwordRecord.option1,
      option2: passwordRecord.option2,
      option3: passwordRecord.option3,
    },
  });
  const onSubmit = async (values) => {
    passwordRecord.title = values.title;
    passwordRecord.link = values.link;
    passwordRecord.username = values.fusername;
    passwordRecord.password = values.fpassword;
    passwordRecord.option1 = values.option1;
    passwordRecord.option2 = values.option2;
    passwordRecord.option3 = values.option3;
    submitRecord(passwordRecord);
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <div
        className="container-fluid"
        style={{
          backgroundColor: "white",
          borderRadius: "25px",
          padding: "1rem",
        }}
      >
        <div className="row my-2 justify-content-center">
          <div className="col-12 inter inter-medium">
            <input
              className="form-control"
              name="title"
              {...register("title", {
                required: true,
              })}
              placeholder={window.sys_app_translate("Title", lang) + " *"}
            />
          </div>
        </div>
        <div className="row my-2 justify-content-center">
          <div className="col-12 inter inter-medium">
            <input
              className="form-control"
              name="link"
              type="url"
              {...register("link", {
                required: true,
              })}
              placeholder={window.sys_app_translate("Link", lang) + " *"}
            />
          </div>
        </div>
        <div className="row my-2 justify-content-center">
          <div className="col-12 inter inter-medium">
            <input
              className="form-control"
              name="fusername"
              {...register("fusername", {
                required: true,
              })}
              autoComplete="off"
              placeholder={window.sys_app_translate("Username", lang) + " *"}
            />
          </div>
        </div>
        <div className="row my-2 justify-content-center">
          <div className="col-12 inter inter-medium">
            <input
              className="form-control"
              name="fpassword"
              type="password"
              {...register("fpassword", {
                required: true,
              })}
              autoComplete="off"
              placeholder={window.sys_app_translate("Password", lang) + " *"}
            />
          </div>
        </div>
        <div className="row my-2 justify-content-center">
          <div className="col-12 inter inter-medium">
            <input
              className="form-control"
              name="option1"
              {...register("option1", {
                required: false,
              })}
              autoComplete="off"
              placeholder={window.sys_app_translate("Option 1", lang)}
            />
          </div>
        </div>
        <div className="row my-2 justify-content-center">
          <div className="col-12 inter inter-medium">
            <input
              className="form-control"
              name="option2"
              {...register("option2", {
                required: false,
              })}
              autoComplete="off"
              placeholder={window.sys_app_translate("Option 2", lang)}
            />
          </div>
        </div>
        <div className="row my-2 justify-content-center">
          <div className="col-12 inter inter-medium">
            <input
              className="form-control"
              name="option3"
              {...register("option3", {
                required: false,
              })}
              autoComplete="off"
              placeholder={window.sys_app_translate("Option 3", lang)}
            />
          </div>
        </div>
        <div className="row my-2">
          <div className="col-12">
            <Button
              variant="contained"
              style={{ width: "100%" }}
              className="inter inter-bold"
              type="submit"
            >
              {window.sys_app_translate(isUpdate ? "Update" : "Create", lang)}
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};
